export default "__VITE_PUBLIC_ASSET__7a8cb8a4__"